/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Buildsdescription1Inputs */

const id_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket file berversi yang diunggah untuk sandbox. Build ditetapkan ke artefak dan menentukan apa yang diunduh pemain melalui peluncur.`)
};

const ms_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bundle fail berversi yang dimuat naik untuk sandbox. Binaan ditugaskan kepada artefak dan memacu apa yang pemain muat turun melalui pelancar.`)
};

const da_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versionerede filbundter uploadet til sandboxen. Builds tildeles artefakter og styrer hvad spillere downloader gennem launcher'en.`)
};

const de_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versionierte Dateibündel, die für die Sandbox hochgeladen wurden. Builds werden Artefakten zugewiesen und bestimmen, was Spieler über den Launcher herunterladen.`)
};

const en_us2_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versioned file bundles uploaded for the sandbox. Builds are assigned to artifacts and drive what players download through the launcher.`)
};

const es_es2_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paquetes de archivos versionados subidos para el sandbox. Las compilaciones se asignan a artefactos y determinan lo que los jugadores descargan a través del launcher.`)
};

const es_mx2_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paquetes de archivos con versiones subidos para el sandbox. Las compilaciones se asignan a artefactos y determinan lo que los jugadores descargan a través del launcher.`)
};

const fil_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga bersyong file bundle na in-upload para sa sandbox. Ang mga build ay nakatalaga sa mga artifact at nagtutulak kung ano ang dina-download ng mga manlalaro sa pamamagitan ng launcher.`)
};

const fr_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paquets de fichiers versionnés téléversés pour le sandbox. Les compilations sont assignées aux artefacts et déterminent ce que les joueurs téléchargent via le launcher.`)
};

const it_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacchetti di file versionati caricati per il sandbox. Le build sono assegnate agli artefatti e determinano ciò che i giocatori scaricano tramite il launcher.`)
};

const hu_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verziózott fájlcsomagok feltöltve a sandbox-hoz. A build-ek artefaktumokhoz vannak rendelve, és meghatározzák, hogy a játékosok mit töltenek le a launcheren keresztül.`)
};

const nl_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versie bestandsbundels geüpload voor de sandbox. Builds worden toegewezen aan artefacten en bepalen wat spelers downloaden via de launcher.`)
};

const no_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versjonerte filbunter lastet opp for sandboxen. Builds er tildelt artefakter og driver hva spillere laster ned gjennom launcher.`)
};

const pl_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wersjonowane pakiety plików przesłane dla sandboxa. Kompilacje są przypisywane do artefaktów i decydują o tym, co gracze pobierają przez launcher.`)
};

const pt_br2_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacotes de arquivos versionados enviados para o sandbox. As builds são atribuídas a artefatos e determinam o que os jogadores baixam pelo launcher.`)
};

const pt_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pacotes de ficheiros versionados enviados para a sandbox. As compilações são atribuídas a artefactos e determinam o que os jogadores descarregam através do launcher.`)
};

const ro_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pachete de fișiere versionate încărcate pentru sandbox. Compilările sunt atribuite artefactelor și determină ceea ce jucătorii descarcă prin launcher.`)
};

const fi_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versioidut tiedostopaketit, jotka on ladattu hiekkalaatikolle. Koontiversiot liitetään artfakteihin ja määräävät, mitä pelaajat lataavat launcherin kautta.`)
};

const sv_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versionshanterade filpaket som laddats upp för sandlådan. Byggen tilldelas artefakter och styr vad spelare laddar ner via launchern.`)
};

const vi_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Các gói tệp phiên bản được tải lên cho sandbox. Bản dựng được gán cho artefact và điều khiển những gì người chơi tải xuống qua launcher.`)
};

const tr_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox için yüklenen sürümlendirilmiş dosya paketleri. Yapılar, yapıtlara atanır ve oyuncuların başlatıcı aracılığıyla indirdiklerini belirler.`)
};

const cs_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verzované balíčky souborů nahrané pro sandbox. Sestavení jsou přiřazena k artefaktům a určují, co hráči stahují přes launcher.`)
};

const bg_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Версионирани файлови пакети, качени за sandbox-а. Компилациите се присвояват на артефакти и определят какво играчите изтеглят чрез лаунчъра.`)
};

const ru_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Версии пакетов файлов, загруженных для песочницы. Сборки назначаются артефактам и определяют, что именно игроки скачивают через лаунчер.`)
};

const uk_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Версійовані пакунки файлів, завантажені для Sandbox. Збірки призначаються артефактам і визначають, що гравці завантажують через лаунчер.`)
};

const ar_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حزم ملفات مُرقمة تم تحميلها لـ Sandbox. تُخصص البنيات للتحف وتحدد ما يقوم اللاعبون بتنزيله من خلال المشغل.`)
};

const hi_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सैंडबॉक्स के लिए अपलोड किए गए संस्करणित फ़ाइल बंडल। बिल्ड कलाकृतियों को सौंपे जाते हैं और यह निर्धारित करते हैं कि खिलाड़ी लॉन्चर के माध्यम से क्या डाउनलोड करते हैं।`)
};

const th_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันเดิลไฟล์ที่มีเวอร์ชันที่อัปโหลดสำหรับแซนด์บ็อกซ์ บิลด์ถูกกำหนดให้กับอาร์ทิแฟกต์และกำหนดสิ่งที่ผู้เล่นดาวน์โหลดผ่าน launcher`)
};

const ja_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サンドボックスにアップロードされたバージョン管理されたファイルバンドル。ビルドはアーティファクトに割り当てられ、プレイヤーがランチャーを通じてダウンロードするものを決定します。`)
};

const zh_cn2_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为沙盒上传的版本化文件捆绑包。构建版本被分配给制品，并驱动玩家通过启动器下载的内容。`)
};

const zh_hant1_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`為沙盒上傳的版本化檔案捆綁包。建置版本被分配給製品，並驅動玩家透過啟動器下載的內容。`)
};

const ko_sandboxes_buildsdescription1 = /** @type {(inputs: Sandboxes_Buildsdescription1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sandbox에 업로드된 버전별 파일 번들입니다. 빌드는 아티팩트에 할당되며 플레이어가 런처를 통해 다운로드하는 내용을 결정합니다.`)
};

/**
* | output |
* | --- |
* | "Versioned file bundles uploaded for the sandbox. Builds are assigned to artifacts and drive what players download through the launcher." |
*
* @param {Sandboxes_Buildsdescription1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_buildsdescription1 = /** @type {((inputs?: Sandboxes_Buildsdescription1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Buildsdescription1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_buildsdescription1(inputs)
	if (locale === "ms") return ms_sandboxes_buildsdescription1(inputs)
	if (locale === "da") return da_sandboxes_buildsdescription1(inputs)
	if (locale === "de") return de_sandboxes_buildsdescription1(inputs)
	if (locale === "en-US") return en_us2_sandboxes_buildsdescription1(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_buildsdescription1(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_buildsdescription1(inputs)
	if (locale === "fil") return fil_sandboxes_buildsdescription1(inputs)
	if (locale === "fr") return fr_sandboxes_buildsdescription1(inputs)
	if (locale === "it") return it_sandboxes_buildsdescription1(inputs)
	if (locale === "hu") return hu_sandboxes_buildsdescription1(inputs)
	if (locale === "nl") return nl_sandboxes_buildsdescription1(inputs)
	if (locale === "no") return no_sandboxes_buildsdescription1(inputs)
	if (locale === "pl") return pl_sandboxes_buildsdescription1(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_buildsdescription1(inputs)
	if (locale === "pt") return pt_sandboxes_buildsdescription1(inputs)
	if (locale === "ro") return ro_sandboxes_buildsdescription1(inputs)
	if (locale === "fi") return fi_sandboxes_buildsdescription1(inputs)
	if (locale === "sv") return sv_sandboxes_buildsdescription1(inputs)
	if (locale === "vi") return vi_sandboxes_buildsdescription1(inputs)
	if (locale === "tr") return tr_sandboxes_buildsdescription1(inputs)
	if (locale === "cs") return cs_sandboxes_buildsdescription1(inputs)
	if (locale === "bg") return bg_sandboxes_buildsdescription1(inputs)
	if (locale === "ru") return ru_sandboxes_buildsdescription1(inputs)
	if (locale === "uk") return uk_sandboxes_buildsdescription1(inputs)
	if (locale === "ar") return ar_sandboxes_buildsdescription1(inputs)
	if (locale === "hi") return hi_sandboxes_buildsdescription1(inputs)
	if (locale === "th") return th_sandboxes_buildsdescription1(inputs)
	if (locale === "ja") return ja_sandboxes_buildsdescription1(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_buildsdescription1(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_buildsdescription1(inputs)
	return ko_sandboxes_buildsdescription1(inputs)
});
export { sandboxes_buildsdescription1 as "sandboxes.buildsDescription" }